import { Row } from "@/components/Row";
import { Text } from "@/components/Text";

// One labeled count in a card's breakdown, under its headline number.
export const SadieBreakdownRow = ({
  count,
  label,
}: {
  count: number;
  label: string;
}) => (
  <Row className="items-center justify-between gap-2">
    <Text className="text-xs font-normal text-slate-600">{label}</Text>
    <Text className="text-xs font-semibold tabular-nums text-slate-900">
      {count.toLocaleString()}
    </Text>
  </Row>
);
